import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 md:py-20 px-4 bg-dark" data-id="element-47">
      <div className="max-w-4xl mx-auto" data-id="element-48">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-dark-guarantee border border-amber/30 rounded-2xl md:rounded-3xl p-6 sm:p-10 md:p-16 flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-49">
          <div className="w-36 h-36 md:w-56 md:h-56 shrink-0 rounded-full border-4 border-amber/60 flex flex-col items-center justify-center p-3 md:p-4 text-center bg-dark relative shadow-[0_0_40px_rgba(230,157,79,0.08)]" data-id="element-50">
            <ShieldCheckIcon className="w-10 h-10 md:w-16 md:h-16 text-amber mb-1 md:mb-3" data-id="element-51" />
            <span className="text-ivory font-black text-base md:text-xl leading-tight" data-id="element-52">
              14 DAY
            </span>
            <span className="text-amber text-xs md:text-sm font-bold tracking-widest mt-0.5 md:mt-1" data-id="element-53">
              MONEY BACK
            </span>
            <span className="text-amber text-xs md:text-sm font-bold tracking-widest" data-id="element-54">
              GUARANTEE
            </span>
          </div>

          <div className="flex-1" data-id="element-55">
            <h3 className="font-heading text-2xl sm:text-3xl md:text-4xl font-black text-ivory mb-4 md:mb-6 uppercase tracking-tight text-center md:text-left" data-id="element-56">
              The "Probe-Tender" Guarantee
            </h3>
            <p className="text-smoke text-base md:text-xl leading-relaxed mb-6 md:mb-8 text-center md:text-left" data-id="element-57">
              Try the entire Pitmaster System for 14 full days. Use it on your
              next cook. If your meat isn't noticeably more tender, juicy, and
              flavorful — or if you just don't love it — email us and get every
              penny back. No questions. No hassle. We'll even let you keep the
              guide.
            </p>
            <p className="text-amber font-bold italic text-lg md:text-xl text-center md:text-left" data-id="element-58">
              — Jake Morrison, Founder
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}